import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { scrollbarBase } from '../../../styles/styles';

const { spacing, colors, common } = THEME;

export const styleSheet = StyleSheet.create({
	defaultPadding: {
		padding: spacing.lg,
	},
	drawer: {
		display: 'flex',
		height: '100%',
	},
	drawerEdge: {
		borderLeft: common.border,
		borderRight: common.border,
		backgroundColor: colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '12px 8px',
		gap: spacing.sm,
		height: '100%',
		boxSizing: 'border-box',
	},
	drawerContent: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		minWidth: 400,
		width: 400,
		maxWidth: 400,
		flex: 1,
		overflowY: 'auto',
		overflowX: 'hidden',
		backgroundColor: colors.background.light,
		borderLeft: common.border,
		...scrollbarBase,
		':is([data-state="inactive"])': {
			display: 'none',
		},
	},
	drawerToolbarContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	drawerButton: {
		position: 'relative',
		width: 40,
		height: 40,
		borderRadius: 20,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: colors.primary.main,
		backgroundColor: colors.primary.light,
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: colors.hover.light,
		},
		':is([data-state="active"])': {
			color: colors.primary.contrastText,
			backgroundColor: colors.primary.main,
		},
		':is([data-state="active"]):after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: -8,
			backgroundColor: colors.primary.main,
			width: 4,
			borderRadius: `0 2px 2px 0`,
			height: '100%',
		},
	},
});
